module.exports = __webpack_public_path__ + "assets/img/672c6a162981a6f5d13dd8dd7caa2b50.svg";